import { useOrderCommentCreate } from "../../../hooks/api/v2/orderComment/useOrderCommentCreate";
import { OrderSendMessageForm } from "./OrderSendMessageForm";

export const SendMessage = ({
  orderId,
  onFocus,
  onBlur,
}: {
  orderId: number;
  onFocus?: () => void;
  onBlur?: () => void;
}) => {
  const mutation = useOrderCommentCreate();
  return (
    <OrderSendMessageForm
      mutation={mutation}
      onBlur={onBlur}
      onFocus={onFocus}
      orderId={orderId}
    />
  );
};
